import React from "react";
import useGlobalMaintenanceQuery from "../../queries/useGlobalMaintenanceQuery";
import MaintenancePage from "../MaintenancePage";

interface MaintenanceGateProps {
  children: React.ReactNode;
}

/**
 * Muestra la pantalla de mantenimiento cuando el ajuste global del producto
 * actual está activo; en caso contrario renderiza la aplicación normalmente.
 */
const MaintenanceGate = ({ children }: MaintenanceGateProps) => {
  const isMaintenanceEnabled = useGlobalMaintenanceQuery();

  if (isMaintenanceEnabled) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};

export default MaintenanceGate;
